let initialState = {
  showIntro: false,
  level: 0,
  id: undefined,
  prevId: []
};

export default function(state = initialState, action){

  switch(action.type){

    case "@@router/LOCATION_CHANGE":
      return {
        ...state,
        isActive: false,
        showIntro: false,
        level: 0,
        minitourId: undefined,
        prevId: []
      };

    case "minitour/START":
      let newPrevId = state.prevId;
      newPrevId.push(state.minitourId);
      return {
        ...state,
        isActive: true,
        showIntro: true,
        level: 0,
        minitourId: action.payload,
        prevId: newPrevId
      };

    case "minitour/BACK":
      newPrevId = state.prevId;
      let newId = newPrevId.pop();
      return {
        ...state,
        isActive: state.prevId.length > 0,
        showIntro: false,
        level: state.prevId.length > 0 ? 1 : 0,
        minitourId: newId,
        prevId: newPrevId
      };

    case "minitour/NEXT":
      return {
        ...state,
        showIntro: false,
        level: state.level + 1,
        minitourId: action.payload
      };


    default: return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/minitour.js